import { ReactNode } from 'react';
import { FeatureGate } from '@/components/FeatureGate';
import { useVocabularyListsAccess } from '@/hooks/useFeatureAccess';

interface ListsGateProps {
  children: ReactNode;
}

/**
 * Route protection component for vocabulary lists feature.
 * Redirects non-admin users to /vocabulary when feature flag is disabled.
 */
export function ListsGate({ children }: ListsGateProps) {
  return (
    <FeatureGate useAccess={useVocabularyListsAccess} fallbackPath="/vocabulary">
      {children}
    </FeatureGate>
  );
}
